import React, { Component } from 'react';
import i18n from '../../../i18n';
import '../../../styles/components/category-pills.scss';
import { getCategories } from '../../../models/categories';

const current_lng = localStorage.getItem('I18N_LANGUAGE');

export class CategoryPills extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: [],
            activeCategory: props.activeCategory || 'all',
            showDropdown: false,
            loading: false,
        };
        this.scrollRef = React.createRef();
        this.dropdownRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        this.loadCategories();
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(e) {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(e.target)) {
            this.setState({ showDropdown: false });
        }
    }

    async loadCategories() {
        this.setState({ loading: true });
        try {
            const response = await getCategories('active=1');
            if (response) {
                this.setState({ categories: response.data || [], loading: false });
            }
        } catch (e) {
            this.setState({ loading: false });
        }
    }

    selectCategory = (id) => {
        this.setState({ activeCategory: id, showDropdown: false });
        this.props.onCategoryChange?.(id);
    };

    scrollLeft = () => {
        if (this.scrollRef.current) {
            this.scrollRef.current.scrollBy({ left: -200, behavior: 'smooth' });
        }
    };

    scrollRight = () => {
        if (this.scrollRef.current) {
            this.scrollRef.current.scrollBy({ left: 200, behavior: 'smooth' });
        }
    };

    render() {
        const { categories, activeCategory } = this.state;

        // Filter out category with id 10
        const filteredCategories = categories.filter(cat => cat.id !== 10);

        // Find active category name for the dropdown header
        let activeCatName = i18n.t('all_categories') || 'All Categories';
        if (activeCategory !== 'all') {
            const cat = filteredCategories.find(c => String(c.id) === String(activeCategory));
            if (cat) {
                activeCatName = current_lng === 'ar' ? (cat.category_name_ar || cat.category_name) : cat.category_name;
            }
        }

        return (
            <div className="cp-wrap">

                {/* ── Horizontal pills row ── */}
                <div className="cp-pills-row">

                    <div className="cp-pills-scroll" ref={this.scrollRef}>
                        {filteredCategories.map(cat => {
                            const name = current_lng === 'ar'
                                ? (cat.category_name_ar || cat.category_name)
                                : cat.category_name;
                            const isActive = String(activeCategory) === String(cat.id);

                            return (
                                <button
                                    key={cat.id}
                                    className={`cp-pill ${isActive ? 'cp-pill--active' : ''}`}
                                    onClick={() => this.selectCategory(cat.id)}
                                >
                                    {cat.file_category_image && (
                                        <img src={cat.file_category_image} alt="" className="cp-pill__icon" />
                                    )}
                                    <span className="cp-pill__label">{name}</span>
                                </button>
                            );
                        })}
                    </div>

                </div>

                {/* <div className="cp-dropdown" ref={this.dropdownRef}>
                    <button className="cp-dropdown__trigger">
                        <span className="cp-dropdown__label">
                            {activeCategory !== 'all' && (
                                <img
                                    src={filteredCategories.find(c => String(c.id) === String(activeCategory))?.file_category_image || ''}
                                    alt=""
                                    className="cp-dropdown__icon-img"
                                />
                            )}
                            {activeCatName}
                        </span>
                    </button>
                </div> */}
            </div>
        );
    }
}

export default CategoryPills;